module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldCondIt.0637a5f.woff";